import { ReactNode } from "react";
import { NavLink } from "react-router";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { CustomerName } from "@/services/backend/customers/components/customer-name";
import { ProcessNumber } from "@/services/backend/numbers/components/process-number";

/**
 * RltBreadcrumbs renders the breadcrumb prefix shared by every RLT page
 * (Customer > Process). Pages append their own trailing crumbs as children,
 * e.g. a BreadcrumbSeparator followed by a BreadcrumbItem with a BreadcrumbLink
 * (intermediate) or BreadcrumbPage (current page).
 */
export function RltBreadcrumbs({
  customerId,
  processId,
  children,
}: {
  customerId: string | null | undefined;
  processId: string;
  children?: ReactNode;
}) {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem className="hidden md:block">
          <BreadcrumbLink asChild>
            <NavLink
              to={`/customers/${customerId}`}
              aria-disabled={!customerId}
            >
              <CustomerName customerId={customerId} />
            </NavLink>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem className="hidden md:block">
          <BreadcrumbLink asChild>
            <NavLink to={`/processes/rlt/${processId}`}>
              <ProcessNumber processId={processId} className="font-mono" />
            </NavLink>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {children}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
